import "./KPICard.css";

const KPICard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  trendLabel, 
  color = "primary",
  size = "medium" 
}) => {
  const trendClass = trend ? (trend > 0 ? "up" : trend < 0 ? "down" : "neutral") : "";

  return (
    <div className={`kpi-card kpi-${color} kpi-${size}`}>
      {icon && <div className="kpi-icon">{icon}</div>}
      
      <div className="kpi-content">
        <div className="kpi-label">{title}</div>
        
        <div className="kpi-value-container">
          <div className="kpi-value">{value}</div>
          {trend !== undefined && (
            <div className={`kpi-trend ${trendClass}`}>
              {trend > 0 && "↑"}
              {trend < 0 && "↓"}
              {trend === 0 && "→"}
              {trendLabel && <span>{Math.abs(trend)}{trendLabel}</span>}
            </div>
          )}
        </div>

        {subtitle && <div className="kpi-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default KPICard;
